import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { Field, Form as FinalForm } from "react-final-form";
import { FORM_ERROR } from "final-form";

// reactstrap components
import {
  Button,
  Row,
  Col,
  Form,
  FormGroup,
  Card,
  TabContent,
  TabPane,
} from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import { IResultUploadFilesDto, PresentationDetailsFormValues, PresentationLanguagesFormValues } from "../../app/models/repositoryUser";
import Loader from "../common/Loader";
import LoaderModal from "../common/LoaderModal";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import FileField from "../common/FileField";
import TextInput from "../common/TextInput";
import InfoMessage from "../common/InfoMessage";
import { toast } from "react-toastify";
import CustomFileField from "../common/CustomFileField";

export interface PresentationDetailsParams {
   parentNodeId?: number;
   presentationId? : number;
   presentationDetailId? :number;
   onNodeSubmit: (dto : IResultUploadFilesDto) => void;
   EditPresentationTitle?: boolean
   isVisibleOnPodium?: boolean
  }
  

const GlobalGuestUploadForm: React.FC<PresentationDetailsParams> = (
    {
      parentNodeId,
     presentationId,
     presentationDetailId,
     EditPresentationTitle,
     isVisibleOnPodium,
    onNodeSubmit}
) => {

    const rootStore = useContext(RootStoreContext);
    const {
        loadingLanguages,
      } = rootStore.commonStore;
    const { theme } = rootStore.commonStore;
    const [isModalLoader, setIsModalLoader] = useState(false);
    const{  
        addPresentation,
        addPresentationNode,
        updatePresentation,
        addPresentationMessage
    }= rootStore.presentationStore
    const [formValues, setFormValues] = useState(new PresentationDetailsFormValues({
      languages: [
        {id: 1, name: "Italiano", locale: "it-IT", flagIcon: "it"}],
      mainLanguageId:"1",
       selectedLanguages:[1],
       presentationLanguages:[
        ],
       id:0
  }));
    const [t] = useTranslation(["guest"], translationHookOptions);
    const [activeTab, setActiveTab] = useState("1");

if (loadingLanguages ) return <Loader />;


   return(<> 
    
    <FinalForm
     mutators={{
      setTitle: (args, state, utils) => {
        const index = args[0];
        const filename = args[1];
        if (filename) {
          const titleField = state.fields[`presentationLanguages[${index}].title`];
          if (titleField && titleField.lastFieldState && (titleField.lastFieldState.value === "" || titleField.lastFieldState.value === undefined)) {
            titleField.change(filename.substr(0, filename.lastIndexOf(".")));
          }
        }
      },
    }}
    initialValues={formValues}
    onSubmit={(values : PresentationDetailsFormValues)=>{
        let formToSend= new PresentationDetailsFormValues({
            languages:values.languages,
            mainLanguageId:values.mainLanguageId,
            selectedLanguages:[],
            presentationLanguages:[],
            id:values.id
        });
        values.presentationLanguages.forEach(
            (lts:any)=>{
        if (values.selectedLanguages.includes(lts.languageId)) {
            formToSend.presentationLanguages.push(lts);
            formToSend.selectedLanguages.push(lts.languageId);
            }
        })
        if(!presentationId){
          // aggiungo una nuova presentazione
          setIsModalLoader(true);
         addPresentation(parentNodeId, values, isVisibleOnPodium, true)
          .then(
            (dto)=>{   
              console.log(dto.completedPercentage);
              if(dto.completedPercentage === 100){
              setIsModalLoader(false);
              // let title = values.presentationLanguages.find(x => x.languageId==1)?.title
              }
              onNodeSubmit(dto)
            }
        ).catch((error) => {
          toast.error(error.message);
          setIsModalLoader(false);
          return ({
            [FORM_ERROR]: error,
          })
        });
        }else{
            if(!EditPresentationTitle){
              setIsModalLoader(true);
          // Aggiungo contenuti alla presentazione
                  //  console.log("Presentation Id " + presentationId);
                  addPresentationNode(presentationId, values).then(
                    (dto)=>{  
                      var result : IResultUploadFilesDto = {
                        result: presentationId,
                        title: "",
                        code: "",
                        errorfiles: [],
                        
                      }
                      setIsModalLoader(false); 
                      onNodeSubmit(result)}
                ).catch((error) => ({
                    [FORM_ERROR]: error,
                  }));
              }else{
                // Update Title
                setIsModalLoader(true);
                updatePresentation(presentationId, values).then(
                  ()=>{ 
                    var result : IResultUploadFilesDto = {
                      result: presentationId,
                      title: "",
                      code: "",
                      errorfiles: []
                    }
                     setIsModalLoader(false); 
                    onNodeSubmit(result)}
                ).catch((error) => ({
                  [FORM_ERROR]: error,
                }));

              }
            }
          
    }}
    validate={(values)=>{
        let errors = {};
        let errorNum = 0;

        if (
          !values ||
          values.presentationLanguages.length === 0 ||
          !values.presentationLanguages.some((x) => x.title)
          ) {
            errorNum++;
          }
        if (values && values.presentationLanguages.length > 0 &&
          values.presentationLanguages[0].attachedFiles && values.presentationLanguages[0].attachedFiles.length === 0) {
            errorNum++;
          }

        if (errorNum === 0) return errors;
        else return { count: errorNum };
    }}
    render={
        ({
            handleSubmit,
            submitting,
            submitError,
            invalid,
            pristine,
            dirtySinceLastSubmit,
            values,
            form
          }) => (
            <Form onSubmit={handleSubmit} fluid="true">
             <Row>
              <Col sm={12}>
           <TabContent activeTab={activeTab} style={{paddingTop: "0px"}}>
                  {values.selectedLanguages.length === 0 && (
                    <InfoMessage
                      color="primary"
                      message="Non ci sono lingue impostate"
                      icon="fas fa-globe fa-3x"
                    />
                  )}
                  {values.selectedLanguages &&
                    values.selectedLanguages.map((l, index) => (
                      <TabPane
                        key={l}
                        tabId={l.toString()}
                      >
                        <Row>
                          <Col>
                            {/* <Card body className="backgroundColorCard"> */}
                              <Field
                                name={`presentationLanguages[${
                                    values.presentationLanguages.findIndex(
                                      (x) => x.languageId === l
                                    ) > -1
                                      ? values.presentationLanguages.findIndex(
                                          (x) => x.languageId === l
                                        )
                                      : values.presentationLanguages.length
                                  }].languageId`}
                                component={TextInput}
                                placeholder="Nome"
                                type="hidden"
                                className="form-control-alternative"
                                autoComplete="off"
                                defaultValue={l}
                              />
                              <Row>
                                <Col sm={12}>
                                  <FormGroup>
                                    {/* <label
                                      className="form-control-label"
                                      htmlFor={`presentationLanguages[${
                                        values.presentationLanguages.findIndex(
                                          (x) => x.languageId === l
                                        ) > -1
                                          ? values.presentationLanguages.findIndex(
                                              (x) => x.languageId === l
                                            )
                                          : values.presentationLanguages.length
                                      }].title`}
                                    >
                                      Nome Presentazione
                                    </label> */}
                                    <Field
                                    // disabled={AddContent ? true : false}
                                      name={`presentationLanguages[${
                                        values.presentationLanguages.findIndex(
                                          (x) => x.languageId === l
                                        ) > -1
                                          ? values.presentationLanguages.findIndex(
                                              (x) => x.languageId === l
                                            )
                                          : values.presentationLanguages.length
                                      }].title`}
                                      component={TextInput}
                                      // type="text"
                                      type="hidden"
                                      className="form-control-alternative"
                                      autoComplete="off"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              {/* {values.selectedLanguages &&
                                values.selectedLanguages.map((l, index) => ( */}
                                <>
                                  <Row>
                                    <Col sm={12}>
                                      <FormGroup >
                                        {/* <label
                                          className="form-control-label"
                                          htmlFor={`presentationLanguages[${
                                            values.presentationLanguages.findIndex(
                                              (x) => x.languageId === l
                                            ) > -1
                                              ? values.presentationLanguages.findIndex(
                                                  (x) => x.languageId === l
                                                )
                                              : values.presentationLanguages.length
                                          }].attachedFiles`}
                                        >
                                          Documento allegato
                                        </label> */}
                                      <CustomFileField
                                          multiple={true}
                                          enabledUploadedListFile={false}
                                          // show ={true}
                                          name={`presentationLanguages[${
                                            values.presentationLanguages.findIndex(
                                              (x) => x.languageId === l
                                            ) > -1
                                              ? values.presentationLanguages.findIndex(
                                                  (x) => x.languageId === l
                                                )
                                              : values.presentationLanguages.length
                                          }].attachedFiles`}
                                          accept=".jpg,.jpeg,.png,.gif,.pdf,.ppt,.pptx,.mp4,.doc,.docx,.xls,.xlsx"
                                          setTitle={{ index : 
                                            values.presentationLanguages.findIndex(
                                            (x) => x.languageId === l
                                          ) > -1? values.presentationLanguages.findIndex(
                                                (x) => x.languageId === l)
                                            : values.presentationLanguages.length, mutator : form.mutators.setTitle}}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </>
                              {/* ))}      */}
                            {/* </Card> */}
                          </Col>
                        </Row>
             
                      </TabPane>
                    ))} 
                </TabContent>
              </Col>
            </Row>
          
         
            <Row>
              <Col>
                <Button
                disabled={submitting || invalid || (pristine && !dirtySinceLastSubmit)}
                    className="btn loginButton btn-block btn-lg"
                    color="dark"
                    type="submit"
                >
                    {t("upload")}
                
                </Button>
              </Col>
            </Row>
          </Form>
          )
    }
    >
</FinalForm>

<LoaderModal
        size="sm"
        title=""
        message={t(addPresentationMessage)}
        isOpen={isModalLoader}
        toggle={() => {}}
      />
    </>)
}

export default observer(GlobalGuestUploadForm);